/**
 * Copyright © 2017, Rezo Zero
 *
 * @file DefaultPage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import {
    AbstractPage
} from 'starting-blocks'
import $ from 'jquery'
import TweenMax from 'TweenMax'

/**
 * Default Page.
 *
 * @extends {AbstractPage}
 * @private
 */
export default class DefaultPage extends AbstractPage {
    init () {
        super.init()

        // Elements
        this.$footer = $('#footer')
        this.$footerGradient = this.$footer.find('.footer__gradient')

        // Values
        this.navTitle = this.$cont.attr('data-nav-title')
        this.color = this.$cont.attr('data-color')

        this.setFooterColor()
    }

    show () {
        this.setFooterColor()
    }

    getColor () {
        return this.$cont.attr('data-color')
    }

    getImage () {
        return this.$cont.attr('data-image')
    }

    setFooterColor () {
        TweenMax.to(this.$footerGradient, 1, {
            background: `linear-gradient(rgba(0, 0, 0, 0), ${this.color} 50%)`
        })
    }

    onLazyImageProcessed (index) {}

    onResize () {}

    onLazyImageSet (element) {}

    onLazyImageLoad (element) {}
}



// WEBPACK FOOTER //
// ./webpack/js/pages/DefaultPage.js